<template>


  <svg class="icon svg-icon" aria-hidden="true" v-if="icon && icon.startsWith('#')">
    <use :xlink:href="icon"></use>
  </svg>
  <img v-else-if="icon && icon.startsWith('/static')" :src="icon" style="width:20px;transform: translateY(4px)"/>
  <i v-else :class="icon"></i>


</template>
<script>
  export default {
    props: {
      icon: ""
    },
    computed:{

    },
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// sys_code_icon_show.vue?486e8b71